import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { EmployeeInviteService } from '../_services/domainservice/employeeinvite.service';

@Component({
  selector: 'app-accept-invite',
  templateUrl: './accept-invite.component.html',
  styleUrls: ['./accept-invite.component.css']
})
export class AcceptInviteComponent implements OnInit {
  form!: FormGroup;
  submitted = false;
  loading = true;
  errorMessage = '';
  successMessage = '';
  tokenValid = false;
  invitedEmail = '';

  private token = '';

  constructor(
    private readonly fb: FormBuilder,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly invites: EmployeeInviteService,
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      fullName: ['', Validators.required],
      password: ['', [Validators.required, Validators.minLength(8)]],
    });

    this.token = this.route.snapshot.queryParamMap.get('token') || '';
    if (!this.token) {
      this.loading = false;
      this.errorMessage = 'This invite link is missing its token.';
      return;
    }

    this.invites.validateToken(this.token).subscribe({
      next: (res: any) => {
        this.loading = false;
        this.tokenValid = true;
        this.invitedEmail = res?.email || '';
        this.form.patchValue({ fullName: res?.fullName || '' });
      },
      error: () => {
        this.loading = false;
        this.tokenValid = false;
        this.errorMessage = 'This invite link is invalid or has expired. Ask your administrator to send a new one.';
      },
    });
  }

  get f() { return this.form.controls; }

  submit(): void {
    this.submitted = true;
    this.errorMessage = '';
    if (this.form.invalid) { return; }

    this.loading = true;
    const { fullName, password } = this.form.value;
    this.invites.acceptInvite(this.token, fullName, password).subscribe({
      next: () => {
        this.loading = false;
        this.successMessage = 'Your account is ready. Redirecting to sign in...';
        setTimeout(() => this.router.navigate(['/login']), 1500);
      },
      error: (err: any) => {
        this.loading = false;
        const code = err?.error?.code;
        this.errorMessage =
          code === 'WEAK_PASSWORD' ? (err?.error?.errors?.join(' ') || 'Choose a stronger password.') :
            code === 'ALREADY_ACCEPTED' ? 'This invite has already been accepted. Please sign in.' :
              code === 'SEAT_LIMIT_REACHED' ? "Your organization's plan is now full. Ask an admin to upgrade before accepting this invite." :
                'This invite link is invalid or has expired.';
      },
    });
  }
}
